import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
  };

  if (variant === 'mobile') {
    return (
      <button
        onClick={toggleLanguage}
        data-testid="language-toggle-mobile"
        className="flex items-center gap-2 text-charcoal hover:text-primary transition-colors"
      >
        <Globe className="w-5 h-5" />
        <span className="text-xs uppercase tracking-wide">
          {i18n.language === 'fr' ? 'EN' : 'FR'}
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={toggleLanguage}
      data-testid="language-toggle"
      className="flex items-center gap-2 px-4 py-2 border gold-border hover:bg-primary hover:text-white transition-all duration-300 uppercase tracking-wider text-sm"
      title={i18n.language === 'fr' ? 'Switch to English' : 'Passer en français'}
    >
      <Globe className="w-4 h-4" />
      <span>{i18n.language === 'fr' ? 'EN' : 'FR'}</span>
    </button>
  );
};

export default LanguageToggle;
